// import ClassStart from '../assets/icons/class-status-start.svg'
import { ReactComponent as ClassStart } from '../assets/icons/class-status-start.svg'
import { ReactComponent as ClassStatus } from '../assets/icons/class-status.svg'
// import { ReactComponent as ClassEnd } from '../assets/icons/class-status-end.svg'
import { ReactComponent as ClassDisable } from '../assets/icons/class-status-disable.svg'

import { useEffect, useRef, useState } from 'react'
// import { SessionCard, SessionEditCard } from './ClassSessionCard.jsx'
import SessionEditCard from './SessionEditCard.jsx'
import SessionCard from './SessionCard.jsx'
import { ClassDetailTabFloatingButton } from './FloatingButton.jsx'
import { getSessions } from '../apis/session.ts'
import { useLocation } from 'react-router-dom'

export default function ClassSessionTab({
  semesterId,
  courseId,
  editState,
  addState,
  onStateChange,
  classData,
}) {
  const [selectedCard, setSelectedCard] = useState()
  const location = useLocation()
  console.log(location.state)

  /*************** 차시 조회 API **************/
  useEffect(() => {
    getSessionsApi()
    // eslint-disable-next-line
  }, [editState, addState])
  const [sessionList, setSessionList] = useState()
  const getSessionsApi = async () => {
    const getSessionsResponse = await getSessions({
      courseId: location.state.data.id,
    })

    if (getSessionsResponse.error) {
      console.log(getSessionsResponse)
      return
    } else {
      // console.log(getSessionsResponse.data)
      setSessionList(getSessionsResponse.data)
    }
  }

  /*************** 다음 차시 이동 Ref **************/
  const nextSessionRef = useRef()
  const [isVisible, setIsVisible] = useState(true)
  const scrollToNextSession = () => {
    nextSessionRef?.current?.scrollIntoView({ behavior: 'smooth' })
  }
  useEffect(() => {
    setTimeout(() => {
      if (nextSessionRef.current) {
        nextSessionRef.current.scrollIntoView({ behavior: 'smooth' })
      }
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting)
        },
        { threshold: 0.5 },
      )

      if (nextSessionRef.current) {
        observer.observe(nextSessionRef.current)
      }

      return () => {
        if (nextSessionRef.current) {
          // eslint-disable-next-line
          observer.unobserve(nextSessionRef.current)
        }
      }
    }, 100)
  }, [])

  // console.log(isVisible)
  const nextSession = sessionList
    ?.map((week) => ({
      week: week.week,
      session: week.sessions.find(
        (session) => session.status === 'ONGOING' || session.status === 'UPCOMING',
      ),
    }))
    .find((weekData) => weekData.session !== undefined)

  return (
    <div className='scroll-bar-none relative h-full overflow-y-auto'>
      {sessionList?.map((weeklyItem, weekIndex) => (
        <div key={weekIndex} className='relative mb-20 flex w-full flex-col gap-40'>
          <div className='sticky top-0 z-30'>
            <p className='relative z-[3] bg-background-default text-title3-bold text-label-strong'>
              {`${weeklyItem.week}주차`}
            </p>
          </div>
          <div className='flex flex-col gap-[18px]'>
            {weeklyItem.sessions.map((sessionItem, sessionIndex) => (
              <div
                ref={
                  selectedCard
                    ? selectedCard === sessionItem.id
                      ? nextSessionRef
                      : null
                    : nextSession?.session === sessionItem
                      ? nextSessionRef
                      : null
                }
                key={sessionIndex}
                className='flex w-full scroll-mt-80 items-center gap-16'
              >
                <div className={`relative flex w-[52px] justify-center`}>
                  <div
                    className={`absolute -top-60 h-40 w-[1px] ${addState || editState ? 'bg-border-default' : nextSession?.session === sessionItem ? 'bg-mint-80' : sessionItem.status === 'COMPLETED' ? 'bg-mint-80' : 'bg-border-default'}`}
                  />
                  {nextSession?.session === sessionItem ? (
                    addState || editState ? (
                      <ClassDisable />
                    ) : (
                      <ClassStart />
                    )
                  ) : (
                    <div
                      className={`${addState || editState ? 'fill-label-placeholder stroke-border-default' : sessionItem.status === 'COMPLETED' ? 'stroke-inverse-primary' : 'fill-label-placeholder stroke-border-default'}`}
                    >
                      <ClassStatus />
                    </div>
                  )}
                </div>
                <div className='w-full'>
                  {sessionItem.id === selectedCard && editState ? (
                    <SessionEditCard
                      semesterId={location.state.data.semester.id}
                      lesson={sessionItem}
                      onStateChange={onStateChange}
                      setSelectedCard={setSelectedCard}
                      courseId={location.state.data.id}
                    />
                  ) : (
                    <SessionCard
                      lesson={sessionItem}
                      getSelectedCard={setSelectedCard}
                      onStateChange={onStateChange}
                      isNextSession={nextSession?.session === sessionItem ? true : false}
                      getSessionsApi={() => getSessionsApi()}
                      addState={addState}
                      editState={editState}
                      classData={location.state.data}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {!isVisible && (
        <div onClick={scrollToNextSession} className='w-full'>
          <ClassDetailTabFloatingButton editState={editState} />
        </div>
      )}
    </div>
  )
}
